// src/components/map/utils/networkMapStyles.ts
//
// Pure helper functions for building Mapbox GL style expressions
// used by network visualization layers.
import {
  FACILITY_ZOOM_STOPS,
  buildInterpolatedIconSizeExpression
} from "./facilityIconSizeExpressions";

/**
 * Build a Mapbox `interpolate` expression for facility icon sizing
 * that scales with zoom level and a user-configurable icon size multiplier.
 *
 * @param facilityIconSize - The user-configured facility icon size multiplier.
 * @returns A Mapbox style expression suitable for `icon-size` layout property.
 */
export function buildFacilityIconSizeExpression(facilityIconSize: number): unknown[] {
  return buildInterpolatedIconSizeExpression(FACILITY_ZOOM_STOPS, facilityIconSize);
}
